import { useNavigate } from 'react-router-dom'
import { mockAuthData } from 'mocks/mockData'
import useSettings from './useSettings'

interface MockAuth {
  // fn to add a mock access token, update signin status, and redirect to dashboard
  mockAuthIfMocking: () => void
}

/**
 * This hook provides a method to simulate a completed auth flow by redirecting to
 * the callback page like the 2nd /authorize would do
 * @returns @see MockAuth an obj with the mockAuthIfMocking function
 */
const useMockAuth = (): MockAuth => {
  const navigate = useNavigate()
  const { isMockDataEnabled } = useSettings()
  const authPostError = sessionStorage.getItem('auth_post_error')

  const mockAuthIfMocking = () => {
    if (isMockDataEnabled) {
      // simulates error from the second authorize request to test that error handling
      authPostError === 'true'
        ? navigate(mockAuthData.authPostError)
        : navigate(mockAuthData.tokenPageURL)
    }
  }

  return {
    mockAuthIfMocking
  }
}

export default useMockAuth
